import {type ICarrierAdminAuthorizationConfig} from 'shared/Header/components/data'

export interface ICarrierAdminQRPageAccessRights {
    OfferMenu: string
    ManageQRSpotRATEOffers: string
    ViewQRSPOTofferqueue: string
    Marketplace: string
    Booking: string
    SearchAvailabilityAndPrice: string
    SearchAvailableSpace: string
    SearchAirWaybillStock: string
    CreateModifyBookingNew: string
    CreateModifyBookingOld: string
    CreateMultipleBookings: string
    CreateModifyBookingTemplates: string
    CreateSpreadsheetBookings: string
    CreateAirWaybillStockRequest: string
    CreateAllotmentRequest: string
    ViewAllotmentStatus: string
    ViewRateEstimate: string
    ViewCarrierSchedules: string
    UpdateAirWaybillStatus: string
    Efreight: string
    CreateRetrieveMAWB: string
    CreateModifyHAWB: string
    CreateModifyHAWBTemplates: string
    CreateModifyPieceIDInfo: string
    ManageShipments: string
    TrackShipments: string
    SearchAirWaybills: string
    ViewModifyBooking: string
    ReviewActiveQueuedBookings: string
    PrintBarcodeShippingLabel: string
    PrintShipperLetterOfInstruction: string
    MakeOnlinePayments: string
    ViewFlightStatus: string
    ViewCustomsStatus: string
    ViewArchivedAirWaybill: string
    ShipmentReleaseDeclaration: string
    eClaims: string
    FileDamageReport: string
    ViewDamageReportStatus: string
    CreateModifyPreliminaryClaim: string
    CreateModifyFinalClaim: string
}

export interface ICarrierAdminQRAuthorizationConfig {
    isAministratorStatus: boolean
    isLevelofAdminRight: boolean
    isGSAStatus: boolean
    isAllocation: boolean
    isRating: boolean
}

const CarrierAdminQR = () => {
    const carrierAdminQRConfigKey1: ICarrierAdminQRAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminQRValue1: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // Create more CarrierAdminAuthorizationConfig instances for other configurations

    const carrierAdminQRConfigKey2: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminQRValue2: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey3: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminQRValue3: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey4: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue4: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey5: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminQRValue5: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey6: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminQRValue6: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey7: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminQRValue7: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey8: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: true,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue8: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // AministratorStatus is denied

    const carrierAdminQRConfigKey9: ICarrierAdminQRAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminQRValue9: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey10: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminQRValue10: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey11: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminQRValue11: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey12: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue12: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey13: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: true
    }

    const carrierAdminQRValue13: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey14: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: true
    }

    const carrierAdminQRValue14: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'Y',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey15: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: true,
        isRating: false
    }

    const carrierAdminQRValue15: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'Y',
        CreateModifyBookingNew: 'Y',
        CreateModifyBookingOld: 'Y',
        CreateMultipleBookings: 'Y',
        CreateModifyBookingTemplates: 'Y',
        CreateSpreadsheetBookings: 'Y',
        CreateAirWaybillStockRequest: 'Y',
        CreateAllotmentRequest: 'Y',
        ViewAllotmentStatus: 'Y',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'Y',
        CreateModifyHAWBTemplates: 'Y',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'Y',
        ReviewActiveQueuedBookings: 'Y',
        PrintBarcodeShippingLabel: 'Y',
        PrintShipperLetterOfInstruction: 'Y',
        MakeOnlinePayments: 'Y',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey16: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: true,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue16: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'Y',
        SearchAvailableSpace: 'Y',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'Y',
        UpdateAirWaybillStatus: 'Y',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'Y',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'Y',
        ManageShipments: 'Y',
        TrackShipments: 'Y',
        SearchAirWaybills: 'Y',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'Y',
        ViewCustomsStatus: 'Y',
        ViewArchivedAirWaybill: 'Y',
        ShipmentReleaseDeclaration: 'Y',
        eClaims: 'Y',
        FileDamageReport: 'Y',
        ViewDamageReportStatus: 'Y',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    // GSA Status Denied

    const carrierAdminQRConfigKey17: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: true,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue17: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'Y',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const carrierAdminQRConfigKey18: ICarrierAdminAuthorizationConfig = {
        isAministratorStatus: false,
        isLevelofAdminRight: false,
        isGSAStatus: false,
        isAllocation: false,
        isRating: false
    }

    const carrierAdminQRValue18: ICarrierAdminQRPageAccessRights = {
        OfferMenu: 'Y',
        ManageQRSpotRATEOffers: 'N',
        ViewQRSPOTofferqueue: 'N',
        Marketplace: 'N',
        Booking: 'Y',
        SearchAvailabilityAndPrice: 'N',
        SearchAvailableSpace: 'N',
        SearchAirWaybillStock: 'N',
        CreateModifyBookingNew: 'N',
        CreateModifyBookingOld: 'N',
        CreateMultipleBookings: 'N',
        CreateModifyBookingTemplates: 'N',
        CreateSpreadsheetBookings: 'N',
        CreateAirWaybillStockRequest: 'N',
        CreateAllotmentRequest: 'N',
        ViewAllotmentStatus: 'N',
        ViewRateEstimate: 'N',
        ViewCarrierSchedules: 'N',
        UpdateAirWaybillStatus: 'N',
        Efreight: 'Y',
        CreateRetrieveMAWB: 'N',
        CreateModifyHAWB: 'N',
        CreateModifyHAWBTemplates: 'N',
        CreateModifyPieceIDInfo: 'N',
        ManageShipments: 'Y',
        TrackShipments: 'N',
        SearchAirWaybills: 'N',
        ViewModifyBooking: 'N',
        ReviewActiveQueuedBookings: 'N',
        PrintBarcodeShippingLabel: 'N',
        PrintShipperLetterOfInstruction: 'N',
        MakeOnlinePayments: 'N',
        ViewFlightStatus: 'N',
        ViewCustomsStatus: 'N',
        ViewArchivedAirWaybill: 'N',
        ShipmentReleaseDeclaration: 'N',
        eClaims: 'Y',
        FileDamageReport: 'N',
        ViewDamageReportStatus: 'N',
        CreateModifyPreliminaryClaim: 'N',
        CreateModifyFinalClaim: 'N'
    }

    const adminHashMap = new Map<ICarrierAdminAuthorizationConfig, ICarrierAdminQRPageAccessRights>()
    adminHashMap.set(carrierAdminQRConfigKey1, carrierAdminQRValue1)
    adminHashMap.set(carrierAdminQRConfigKey2, carrierAdminQRValue2)
    adminHashMap.set(carrierAdminQRConfigKey3, carrierAdminQRValue3)
    adminHashMap.set(carrierAdminQRConfigKey4, carrierAdminQRValue4)
    adminHashMap.set(carrierAdminQRConfigKey5, carrierAdminQRValue5)
    adminHashMap.set(carrierAdminQRConfigKey6, carrierAdminQRValue6)
    adminHashMap.set(carrierAdminQRConfigKey7, carrierAdminQRValue7)
    adminHashMap.set(carrierAdminQRConfigKey8, carrierAdminQRValue8)
    adminHashMap.set(carrierAdminQRConfigKey9, carrierAdminQRValue9)
    adminHashMap.set(carrierAdminQRConfigKey10, carrierAdminQRValue10)
    adminHashMap.set(carrierAdminQRConfigKey11, carrierAdminQRValue11)
    adminHashMap.set(carrierAdminQRConfigKey12, carrierAdminQRValue12)
    adminHashMap.set(carrierAdminQRConfigKey13, carrierAdminQRValue13)
    adminHashMap.set(carrierAdminQRConfigKey14, carrierAdminQRValue14)
    adminHashMap.set(carrierAdminQRConfigKey15, carrierAdminQRValue15)
    adminHashMap.set(carrierAdminQRConfigKey16, carrierAdminQRValue16)
    adminHashMap.set(carrierAdminQRConfigKey17, carrierAdminQRValue17)
    adminHashMap.set(carrierAdminQRConfigKey18, carrierAdminQRValue18)

    return adminHashMap
}
export default CarrierAdminQR
